import { render, staticRenderFns } from "./manual.vue?vue&type=template&id=060d1372&scoped=true"
import script from "./manual.vue?vue&type=script&lang=js"
export * from "./manual.vue?vue&type=script&lang=js"
import style0 from "./manual.vue?vue&type=style&index=0&id=060d1372&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "060d1372",
  null
  
)

export default component.exports